(() => {
  const EXTRA_PX = 45;
  const EPB_SELECTOR = '#epb_container';
  const TARGET_SELECTOR = '.mobile-facets__main';
  const INIT_FLAG = 'epbFacetsOffsetInit';

  if (document.documentElement.dataset[INIT_FLAG] === '1') return;
  document.documentElement.dataset[INIT_FLAG] = '1';

  const mq = window.matchMedia('(max-width: 749px)');

  let epbEl = null;
  let lastMargin = null;
  let rafId = null;

  const getTargets = () => Array.from(document.querySelectorAll(TARGET_SELECTOR));

  const applyMargin = (px) => {
    const targets = getTargets();
    if (!targets.length) return;

    targets.forEach((el) => {
      if (px == null) el.style.marginTop = '';
      else el.style.marginTop = `${px}px`;
    });

    lastMargin = px;
  };

  const isStyleVisible = (el) => {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none') return false;
    if (style.visibility === 'hidden') return false;
    if (parseFloat(style.opacity || '1') <= 0) return false;
    return true;
  };

  const getVisibleHeightPx = (el) => {
    if (!el || !isStyleVisible(el)) return 0;

    const rect = el.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return 0;

    const vh = window.innerHeight || document.documentElement.clientHeight;

    const visibleTop = Math.max(rect.top, 0);
    const visibleBottom = Math.min(rect.bottom, vh);
    const visible = Math.max(0, visibleBottom - visibleTop);

    // Clamp por si acaso
    return Math.min(visible, rect.height);
  };

  const update = () => {
    if (!mq.matches) {
      if (lastMargin !== null) applyMargin(null);
      return;
    }

    const visibleH = getVisibleHeightPx(epbEl);

    if (visibleH > 0) {
      const margin = Math.round(visibleH + EXTRA_PX); 
      if (lastMargin !== margin) applyMargin(margin);
    } else {
      if (lastMargin !== null) applyMargin(null);
    }
  };

  const scheduleUpdate = () => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      update();
    });
  };

  const bindWhenFound = () => {
    if (epbEl) return true;

    epbEl = document.querySelector(EPB_SELECTOR);
    if (!epbEl) return false;

    const moAttrs = new MutationObserver(scheduleUpdate);
    moAttrs.observe(epbEl, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
    });

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    mq.addEventListener?.('change', scheduleUpdate);

    let ticks = 0;
    const pulse = setInterval(() => {
      ticks += 1;
      scheduleUpdate();
      if (ticks >= 40) clearInterval(pulse);
    }, 200);

    scheduleUpdate();
    return true;
  };

  const init = () => {
    if (bindWhenFound()) return;

    const mo = new MutationObserver(() => {
      if (bindWhenFound()) mo.disconnect();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    let tries = 0;
    const t = setInterval(() => {
      tries += 1;
      if (bindWhenFound() || tries >= 100) clearInterval(t); 
    }, 200);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();